import React from "react";
import Menubar from "../Menubar";
import { Mer_dashboard_url } from "../../Services/Configuration";
const token = localStorage.getItem("token");
console.log("Token in Bi component:", token,`${Mer_dashboard_url}?token=${encodeURIComponent(token)}`);
const MER = () => {
  return (
  <>   <Menubar/>
    <div style={{marginTop:"-0.3%"}}>

  <iframe
  // src={`${Mer_dashboard_url}?token=${encodeURIComponent(token)}`}
  src={`${Mer_dashboard_url}?token=${token}`}

  // src={Mer_dashboard_url}
  style={{
    border: 'none',
    width: '100%',
    height: '900px'
  }}
/>
    </div></>
  );
};

export default MER;